module.exports = __webpack_public_path__ + "img/PS1.d793f68b.png";